import type { YouTubeEmbed as YouTubeEmbedType } from '../../lib/embeds/types';

export function YouTubeEmbed({ videoId }: { videoId: YouTubeEmbedType['videoId'] }) {
  const src = `https://www.youtube.com/embed/${videoId}`;
  return (
    <div className="embed embed-youtube" style={{ position: 'relative', paddingTop: '56.25%' }}>
      <iframe
        title="YouTube video"
        src={src}
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        style={{ position: 'absolute', inset: 0, width: '100%', height: '100%', border: 0 }}
      />
    </div>
  );
}
